//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import TbkReport from '@/views/Sale/GTransbankDeposit/TbkReport'

//
export default {
  path: '/transbank_report',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'g_transbank_deposit_summary_report',
            component: TbkReport,
        },
    ],
    meta: {
        title: 'Seguimiento Transbank',
    },
}
